
import React from 'react';
import WebsiteManagementHomePage from "../website-management/website-management-home-page";
import Apps from "../components/Icon/App.jsx";
import websiteManagementRoutes from "../website-management/website-management-routes";
import userManagementRoutes from "../user-management/user-management-routes";
import ManageSocialAccounts from "../manage-social/views/manage-social-accounts";
import AuthorProfileApprovalsPage from "../user-settings/author-profile-approvals-page.jsx";
import settingsIcon from "../assets/icons/settings-icon.png";
const Icon = () => <Apps src={settingsIcon} />;

let settingRoutes = [
  {
    collapse: true,
    path: "/settings",
    name: "Settings",
    state: "openWebsiteManagement",
    icon: Icon,
    isRequiredAuth: true,
    component: WebsiteManagementHomePage,
    requiredPermissions: ["SETTING:WEBSITE_SETTINGS", "SETTING:USER_MANAGEMENT", "SHARE:MANAGE_ACCOUNTS", "CREATE:PUBLISH"],
    views: [
      ...userManagementRoutes,
      ...websiteManagementRoutes,
      {
        path: "/manage-social/manage",
        name: "Manage Social Accounts",
        mini: "MN",
        isRequiredAuth: true,
        component: ManageSocialAccounts,
        requiredFeaturePermision: 'SOCIAL_SCHEDULE',
        requiredPermissions: ["SHARE:MANAGE_ACCOUNTS"]
      },
      {
        path: "/settings/author-profile-approvals",
        name: "Author Profile Approvals",
        mini: "AA",
        isRequiredAuth: true,
        component: AuthorProfileApprovalsPage,
        requiredPermissions: ["CREATE:PUBLISH"]
      },
    ]
  },
]

export default settingRoutes;
